export default function initExpandableText(): void {
    const buttons = document.querySelectorAll<HTMLElement>('.js-btn-expand');
    buttons.forEach(button => new ExpandableText(button));

    const expandableBlocks = document.querySelectorAll<HTMLElement>('.js-expandable-height');
    expandableBlocks.forEach(block => new ExpandableTextHeight(block));
}

/**
 * Toggle un bloc de texte qui a <!--more-->.
 *
 * Utilisation :
 * <div class="text-wrapper">
 *   <div class="text content-wysiwyg js-expandable" style="display:none;">
 *     ...
 *   </div>
 *   <button class="btn-expand js-btn-expand">
 *     <span class="btn-text">Lire d’avantage</span>
 *     {{ svg_content('select-chevron-down') }}
 *   </button>
 * </div>
 *
 */
export class ExpandableText {
    $button: HTMLElement;
    $content: HTMLElement | null;

    constructor($button: HTMLElement) {
        this.$button = $button;
        this.$content = $button.previousElementSibling as HTMLElement | null;
        this.init();
    }

    init(): void {
        if (!this.$content || !this.$content.classList.contains('js-expandable')) {
            return;
        }

        this.$button.addEventListener('click', () => this.toggleContent());
    }

    toggleContent(): void {
        if (!this.$content) {
            return;
        }

        const isExpanded = this.$content.style.display === 'block';
        this.$content.style.display = isExpanded ? 'none' : 'block';

        const btnText = this.$button.querySelector<HTMLElement>('.btn-text');
        if (btnText) {
            btnText.textContent = isExpanded ? 'Lire d\'avantage' : 'Lire moins';
        }

        this.$button.classList.toggle('is-expanded', !isExpanded);
    }
}

/**
 * Toggle un bloc de texte limité en hauteur (max-height: 120px).
 * Le bouton est affiché uniquement si le contenu dépasse 120px.
 *
 * Utilisation :
 * <div class="text-wrapper">
 *   <div class="text content-wysiwyg js-expandable-height">
 *     ...
 *   </div>
 *   <button class="btn-expand js-btn-expand-height" style="display:none;">
 *     <span class="btn-text">Lire d'avantage</span>
 *     {{ svg_content('select-chevron-down') }}
 *   </button>
 * </div>
 */
export class ExpandableTextHeight {
    $block: HTMLElement;
    $button: HTMLElement | null;
    maxHeight: number = 120;

    constructor($block: HTMLElement) {
        this.$block = $block;
        this.$button = $block.nextElementSibling as HTMLElement | null;
        this.init();
    }

    init(): void {
        if (!this.$button) {
            return;
        }

        if (this.$block.scrollHeight > this.maxHeight) {
            this.$button.style.display = 'flex';
        }

        this.$button.addEventListener('click', () => this.toggleContent());
    }

    toggleContent(): void {
        const isExpanded = this.$block.classList.toggle('is-expanded');
        const cardsContainer = this.$block.closest('.content-instances-wrapper');
        if (cardsContainer) {
            if (isExpanded) {
                cardsContainer.classList.add('has-expanded');
            } else {
                const hasOtherExpanded = cardsContainer.querySelector('.js-expandable-height.is-expanded');
                if (!hasOtherExpanded) {
                    cardsContainer.classList.remove('has-expanded');
                }
            }
        }

        const btnText = this.$button?.querySelector<HTMLElement>('.btn-text');
        if (btnText) {
            btnText.textContent = isExpanded ? 'Lire moins' : 'Lire d\'avantage';
        }

        this.$button?.classList.toggle('is-expanded', isExpanded);
    }
}